/* eslint-disable import/no-named-as-default */
// THIS IS NO LONGER USED THE ENTIRE CLEARANCEOTHERUSEANDDURATIONDRAWER CAN BE DELETED
import { compose } from 'redux';
import { withFormConnected } from 'components/styleguide/HOC/index';
import withBaseDrawer from '../withBaseDrawer';
import DRAWERS from '../constants';

export default compose(withBaseDrawer, (c) => withFormConnected(c, { formId: DRAWERS.CLEARANCES_USES_AND_DURATIONS }));
